<template>
  <b-button
    v-if="icon"
    variant="secondary"
    class="banner-action"
    :disabled="buttonProperties.disabled"
    @click="$emit('onClick', buttonProperties)"
  >
    <b-spinner
      v-if="buttonProperties.loading"
      variant="primary"
    />
    <delete-icon
      v-else
      class="banner-group-action-svg"
    />
  </b-button>

  <b-button
    v-else
    :variant="buttonProperties.disabled ? 'secondary' : 'outline-danger'"
    :disabled="buttonProperties.disabled"
    @click="$emit('onClick', buttonProperties)"
  >
    <span> {{ btnLabel }}</span>
    <b-spinner
      v-if="buttonProperties.loading"
      variant="primary"
      class="ml-1"
    />
  </b-button>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import DeleteIcon from '@/@core/components/svg/common/Trash.vue'
import { reactive } from '@vue/composition-api'

export default {
  components: {
    BButton,
    BSpinner,
    DeleteIcon,
  },
  props: {
    icon: { type: Boolean, default: false },
    btnLabel: { type: String, default: 'Delete' },
  },

  setup() {
    const buttonProperties = reactive({
      loading: false,
      disabled: false,
    })

    return { buttonProperties }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/banner/banner-table.css';
@import '~@/assets/css/pages/banner/banner-group.css';
</style>
